var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.917q1.312 0 2.24-.927.927-.928.927-2.24 0-1.312-.927-2.24-.928-.927-2.24-.927-1.312 0-2.24.927-.927.928-.927 2.24 0 1.312.927 2.24.928.927 2.24.927Zm-.333 5.166v-1.5h-1.5v-.666h1.5v-2.334q-1.479-.166-2.49-1.25-1.01-1.083-1.01-2.583 0-.729.26-1.375.261-.646.74-1.25L5.896 5.854 4.833 6.917l-.458-.459 1.063-1.062-2.355-2.334v2.521h-.666V1.917h3.666v.666H3.562l2.334 2.355 1.062-1.063.459.458-1.063 1.063 1.334 1.312q.479-.375 1.072-.583.594-.208 1.24-.208.667 0 1.25.218.583.219 1.062.573l4.126-4.125h-2.521v-.666h3.666v3.666h-.666V3.062l-4.084 4.084q.479.583.74 1.229.26.646.26 1.375 0 1.5-1.01 2.583-1.011 1.084-2.49 1.25v2.334h1.5v.666h-1.5v1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiverse);
export default __webpack_public_path__ + "static/media/diverse.0681668b35bbad31525efd9f5e07d657.svg";
export { ForwardRef as ReactComponent };